var Codec = require('io/codec');
var BEES = require('serialisers/byte-encoded-enum-serialiser');
var UpdateTopicResponse = require('./update-topic-response');

module.exports = {
    read : function(input) {
        var reason = BEES.read(input, UpdateTopicResponse);

        return {
            reason : reason,
            isError : reason !== UpdateTopicResponse.SUCCESS
        };
    },
    write : function(output, request) {
        BEES.write(output, request.reason);
    }
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/~/services/update-topic/update-topic-response-serialiser.js
// module id = 1041
// module chunks = 1